// Settings tabs, split by what they are ABOUT (TDC-1609).
//
//   scope: 'personal' — about the logged-in user. Stays at the root
//     /settings/* mount, because it is the same page whichever brand you
//     belong to.
//   scope: 'brand'    — about the brand. Lives under the brand's canonical
//     portal URL, /portal/:brandSlug/settings/*.
//
// SettingsPage builds each href absolutely from this field, so the two mounts
// render one page with one rail. A relative <NavLink to="team"> would resolve
// against whichever mount happened to be active and land in the wrong space.
export default [
    {
        link: 'profile',
        label: 'Profile',
        scope: 'personal',
    },
    {
        // Renamed from 'brand' now that the tab lives under the brand's portal
        // and sits next to the personal Profile tab in one rail; the old path
        // is kept as an alias route.
        link: 'brand-profile',
        label: 'Brand',
        scope: 'brand',
    },
    {
        link: 'reset-password',
        label: 'Reset Password',
        scope: 'personal',
    },
    {
        // Google + password (components/auth/SignInMethods). Shown to brand
        // and internal staff accounts.
        link: 'sign-in-methods',
        label: 'Sign-in Methods',
        scope: 'personal',
    },
    // {
    //     link: 'update-email',
    //     label: 'Update Email',
    //     scope: 'personal',
    // },
    {
        link: 'team',
        label: 'Team',
        scope: 'brand',
    },
    // {
    //     link: 'subscription',
    //     label: 'Subscription',
    //     scope: 'brand',
    // },
    {
        // Site tag (gt.js), Shopify custom pixel, install check. Every brand
        // account; only the pixel section is plan-gated (was 'google-tag').
        link: 'onboarding',
        label: 'Onboarding',
        scope: 'brand',
    },
    {
        link: 'search-console',
        label: 'Google Search Console',
        scope: 'brand',
    },
    {
        link: 'notifications',
        label: 'Notifications',
        scope: 'brand',
    },
    {
        // Personal API Keys (service account keys): the user's own keys for
        // apps they build. Internal staff only for now (SettingsPage hides it
        // from others).
        link: 'personal-keys',
        label: 'Personal API Keys',
        scope: 'personal',
    },
    {
        link: 'api-keys',
        label: 'Public API Keys',
        scope: 'brand',
    },
    {
        // Brand admins only (router/brandAdminTDC.tsx).
        link: 'white-label',
        label: 'White Label',
        scope: 'brand',
    },
]
